import { ItemDetails } from '@/components/ItemDetails/ItemDetails';
import { PersistedItem } from '@/types/DataModel';

const ItemDetailsTab = ({ item }: { item: PersistedItem }) => {

    // Pass itemData so Catalog View reuses the editor-loaded item and does not
    // issue a second GET /items/{pk} without validate=true.
    return (
        <ItemDetails
            primaryKey={item.primaryKey__}
            itemData={item}
            isInEditorMode={true}
        />
    );
};

export { ItemDetailsTab };
